$(document).ready(function () {
    window.get_global_status = function (status) {
        let icon = status == "A" ? "far fa-thumbs-up" : "far fa-thumbs-down";
        let title = status == "A" ? "Desactivar" : "Activar";
        let color_class = status == "A" ? "success" : "danger";
        return {'icon': icon, 'title': title, 'color_clas': color_class};
    }

    window.get_global_code_status = function (status) {
        let icon = status == "active" ? "far fa-thumbs-up" : "far fa-thumbs-down";
        let title = status == "active" ? "Desactivar" : "Activar";
        let color_class = status == "active" ? "success" : "danger";
        return {'icon': icon, 'title': title, 'color_clas': color_class};
    }

});


